'use strict'

angular
  .module('rmRundown', [])

require('./config')
require('./controllers')
require('./directives')
require('./filters')
require('./resources')
require('./routes')
require('./services')
